/**
 * Single source of truth for every RTK Query API in the app.
 *
 * Used by:
 * - `src/redux/store.ts` — middleware registration
 * - `src/redux/resetAllApiState.ts` — cache clearing on session change
 *
 * When you create a new RTK Query API, add it to this array.
 */
import {
  accountFoldersApi,
  adminNotificationConfigApi,
  advancedSearchesApi,
  affiliationsApi,
  analyticsApi,
  codesApi,
  companiesApi,
  dataIssuesApi,
  discoveryApi,
  emailsApi,
  enrichmentApi,
  exportsApi,
  filterSetsApi,
  globalSearchApi,
  hexApi,
  integrationsApi,
  listsApi,
  medrmApi,
  notificationsApi,
  openPaymentsApi,
  payerMixApi,
  playsApi,
  profileConfigurationApi,
  profilesApi,
  prospectsMetaApi,
  providerCohortsApi,
  providersApi,
  publicationsApi,
  referralsApi,
  regionsApi,
  rolesApi,
  routesApi,
  scoutFeedbackApi,
  scoutThreadsApi,
  settingsApi,
  strategyApi,
  suggestionsApi,
  teamsApi,
  territoryChatApi,
  territoryApi,
  usersApi,
} from 'src/api/redux';
import { educationApi } from 'src/api/redux/education';

export const allApis = [
  accountFoldersApi,
  adminNotificationConfigApi,
  advancedSearchesApi,
  affiliationsApi,
  analyticsApi,
  codesApi,
  companiesApi,
  dataIssuesApi,
  discoveryApi,
  educationApi,
  emailsApi,
  enrichmentApi,
  exportsApi,
  filterSetsApi,
  globalSearchApi,
  hexApi,
  integrationsApi,
  listsApi,
  medrmApi,
  notificationsApi,
  openPaymentsApi,
  payerMixApi,
  playsApi,
  profileConfigurationApi,
  profilesApi,
  prospectsMetaApi,
  providerCohortsApi,
  providersApi,
  publicationsApi,
  referralsApi,
  regionsApi,
  rolesApi,
  routesApi,
  scoutFeedbackApi,
  scoutThreadsApi,
  settingsApi,
  strategyApi,
  suggestionsApi,
  teamsApi,
  territoryChatApi,
  territoryApi,
  usersApi,
] as const;
